/**
 * @generated SignedSource<<6d90a1cef12b89e1c0c3c8342120f12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SaveResetViewSettingsButtonUI$data = {
  readonly id: string;
  readonly viewSettings?: {
    readonly canPublishViewConfig: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "SaveResetViewSettingsButtonUI";
};
export type SaveResetViewSettingsButtonUI$key = {
  readonly " $data"?: SaveResetViewSettingsButtonUI$data;
  readonly " $fragmentSpreads": FragmentRefs<"SaveResetViewSettingsButtonUI">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "groupBy"
    },
    {
      "kind": "RootArgument",
      "name": "issueSearchInput"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "staticViewInput"
    }
  ],
  "kind": "Fragment",
  "name": "SaveResetViewSettingsButtonUI",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "groupBy",
              "variableName": "groupBy"
            },
            {
              "kind": "Variable",
              "name": "issueSearchInput",
              "variableName": "issueSearchInput"
            },
            {
              "kind": "Variable",
              "name": "staticViewInput",
              "variableName": "staticViewInput"
            }
          ],
          "concreteType": "JiraIssueSearchViewConfigSettings",
          "kind": "LinkedField",
          "name": "viewSettings",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canPublishViewConfig"
            }
          ]
        }
      ],
      "type": "JiraSpreadsheetView",
      "abstractKey": "__isJiraSpreadsheetView"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "a0c148b1d38cfb4a1325a7597a2f1928";

export default node;
